import { createApiClient } from '@swarm/api-client';
import { Offline } from '../features/offline/offline';

/** Captures writes while offline and sends them later (ADR 0027). */
export const offline = new Offline();

export const api = createApiClient({ fetch: offline.fetch as typeof globalThis.fetch });
